import { render } from "./FormLogin.vue?vue&type=template&id=b03228e0"
import script from "./FormLogin.vue?vue&type=script&lang=js"
export * from "./FormLogin.vue?vue&type=script&lang=js"

import exportComponent from "/Users/albert/Develop/Dashboard/dashboard-frontend-private/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])